// See https://www.notion.so/landr/16ca40de80e942f3a8f25f9e944dd70a?v=c3689c08477f42418abeced2159777fd
var EventIds = /*#__PURE__*/function (EventIds) {
  EventIds[EventIds["RootComponentUnhandledError"] = 22500] = "RootComponentUnhandledError";
  EventIds[EventIds["ComponentUnhandledError"] = 22501] = "ComponentUnhandledError";
  EventIds[EventIds["ApolloAuthenticationsError"] = 22502] = "ApolloAuthenticationsError";
  EventIds[EventIds["ApolloUnauthorizedError"] = 22503] = "ApolloUnauthorizedError";
  EventIds[EventIds["ApolloInternalServerError"] = 22504] = "ApolloInternalServerError";
  EventIds[EventIds["ApolloNetworkError"] = 22505] = "ApolloNetworkError";
  EventIds[EventIds["ApolloError"] = 22506] = "ApolloError";
  EventIds[EventIds["AnalyticsSendError"] = 22507] = "AnalyticsSendError";
  EventIds[EventIds["SessionUrl"] = 22508] = "SessionUrl";
  EventIds[EventIds["SessionCopyLink"] = 22509] = "SessionCopyLink";
  EventIds[EventIds["SessionSubscription"] = 22510] = "SessionSubscription";
  return EventIds;
}({});

export { EventIds };
